module.exports = __webpack_public_path__ + "static/img/banner1.59c86a94.png";